module.exports = __webpack_public_path__ + "src/assets/img/menu-icon-4-line.b136c7dc.svg";